import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import FuelDailyOperationalDashboardSearchForm from './FuelDailyOperationalDashboardSearchForm';
import FuelDailyOperationalDashboardResult from './FuelDailyOperationalDashboardResult';
import { FUEL_DAILY_OPERATIONAL_DASHBOARD_PATH } from '../../../../config/paths';
import {
  clearFuelDailyOperationalDashboard,
  postFuelDailyOperationalDashboard,
} from '../../../../actions';
import { tzNormalizeDate } from '../../../../utils/date';
import { TIMESTAMP_FORMAT } from '../../../../config/locale';
import Content from '../../../layout/Content';

const periodToDates = (period) => {
  const today = new Date();
  let from = today;
  let to = today;

  if (period === 'week') {
    from = new Date(today);
    from.setDate(from.getDate() - 6);
  } else if (period === 'month') {
    from = new Date(today.getFullYear(), today.getMonth(), 1);
  } else if (period === 'previousMonth') {
    from = new Date(today.getFullYear(), today.getMonth() - 1, 1);
    to = new Date(today.getFullYear(), today.getMonth(), 0);
  }

  return {
    fromDate: tzNormalizeDate({
      date: from,
      format: TIMESTAMP_FORMAT,
      time: 'start',
    }),
    toDate: tzNormalizeDate({
      date: to,
      format: TIMESTAMP_FORMAT,
      time: 'end',
    }),
  };
};

export class FuelDailyOperationalDashboard extends Component {
  componentDidMount() {
    this.loadDashboard({ period: 'today' });
  }

  componentWillUnmount() {
    this.props.dispatchClearFuelDailyOperationalDashboard();
  }

  loadDashboard = (formValues) => {
    const period = formValues.period || 'today';
    let fromDate;
    let toDate;

    if (period === 'custom') {
      fromDate = tzNormalizeDate({
        date: formValues.fromDate,
        format: TIMESTAMP_FORMAT,
        time: 'start',
      });
      toDate = tzNormalizeDate({
        date: formValues.toDate,
        format: TIMESTAMP_FORMAT,
        time: 'end',
      });
    } else {
      const dates = periodToDates(period);
      fromDate = dates.fromDate;
      toDate = dates.toDate;
    }

    const payload = {
      fromDate,
      toDate,
    };

    if (formValues.registeredBusId && formValues.registeredBusId.length) {
      payload.companyBusIds = formValues.registeredBusId.map(({ label }) =>
        String(label),
      );
    }
    if (
      formValues.circuitId !== undefined &&
      formValues.circuitId !== null &&
      formValues.circuitId !== ''
    ) {
      payload.circuitId = formValues.circuitId;
    }
    if (formValues.statuses && formValues.statuses.length > 0) {
      payload.statuses = formValues.statuses;
    }
    if (formValues.includeNorthChicoRoutes) {
      payload.includeNorthChicoRoutes = true;
    }

    this.props.dispatchPostFuelDailyOperationalDashboard(payload);
  };

  onSubmit = (formValues) => {
    this.loadDashboard(formValues);
  };

  render() {
    const { breadcrumbs } = this.props;

    const subtitle = (
      <span>
        Control operativo por circuito (tanque lleno → tanque lleno). Mismas
        exclusiones que el reporte de seguimiento; opcionalmente incluye Norte
        Chico. Filtra por periodo (o rango de fechas), bus, circuito y estado.
      </span>
    );

    const content = (
      <Fragment>
        <FuelDailyOperationalDashboardSearchForm onSubmit={this.onSubmit} />
        <FuelDailyOperationalDashboardResult />
      </Fragment>
    );

    return (
      <Content
        breadcrumbs={breadcrumbs}
        title="Dashboard Operativo Diario – Combustible"
        subtitle={subtitle}
        content={content}
      />
    );
  }
}

const mapStateToProps = ({ TrafficUnit }) => ({
  breadcrumbs: [
    ...TrafficUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Dashboard Operativo Diario – Combustible',
      href: FUEL_DAILY_OPERATIONAL_DASHBOARD_PATH,
    },
  ],
});

const mapDispatchToProps = {
  dispatchPostFuelDailyOperationalDashboard: postFuelDailyOperationalDashboard,
  dispatchClearFuelDailyOperationalDashboard: clearFuelDailyOperationalDashboard,
};

FuelDailyOperationalDashboard.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchPostFuelDailyOperationalDashboard: PropTypes.func.isRequired,
  dispatchClearFuelDailyOperationalDashboard: PropTypes.func.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FuelDailyOperationalDashboard);
